import React from 'react';

const Faq = ({ coin }) => {
  if (!coin?.name) return null;

  return (
    <div className="my-8">
      <h2 className="text-2xl font-bold mb-4">FAQs about {coin.name}</h2>
      <div className="space-y-4">
        <details className="p-4 rounded">
          <summary className="cursor-pointer font-medium">What is {coin.name}?</summary>
          <p className="mt-2">{coin.description?.en?.split('. ')[0]}.</p>
        </details>
        <details className="p-4 rounded">
          <summary className="cursor-pointer font-medium">How can I buy {coin.name}?</summary>
          <p className="mt-2">You can buy {coin.name} on our platform by clicking the Buy button above.</p>
        </details>
        <details className=" p-4 rounded">
          <summary className="cursor-pointer font-medium">Is {coin.name} a good investment?</summary>
          <p className="mt-2">Always do your own research, but {coin.name} has shown significant market interest.</p>
        </details>
      </div>
    </div>
  );
};

export default Faq;
